import { ProductProcessingMode } from 'cloud-shared-lib';
import { PriceListProductBazisElement } from '../../price-list/price-list-product-bazis-element.model';
import { CuttingCadModelMaterialLink } from '../cutting-cad-model-material-link.model';

export class CuttingProduct {
  id: number;
  name: string;
  article: string;
  height: number;
  width: number;
  deep: number;
  count: number;
  elements: PriceListProductBazisElement[];
  loadingState: LoadingStateEnum;
  originalHeight: number;
  originalWidth: number;
  originalDeep: number;
  fileName: string;
  sign: string;
  price: number;
  parsedMaterials: CuttingCadModelMaterialLink[];
  processingMode: ProductProcessingMode;
  priceListProductId: number;
}

export enum LoadingStateEnum {
  Added,
  ProductMaterialParsed,
  ProductMaterialLinked,
  ProductMaterialReplaced,
  Completed,
  Error,
}
